import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import { LeadFormParameters } from 'components/LeadForm/LeadForm.data';
import styles from 'pages/benefits/brand-reliability/BrandReliability.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Benefits/BrandReliability/components/SectionHeader'));
const SectionPitch = dynamic(() => import('sections/Benefits/BrandReliability/components/SectionPitch'));
const SectionCards = dynamic(() => import('sections/Benefits/BrandReliability/components/SectionCards'));
const SectionFaq = dynamic(() => import('sections/Benefits/BrandReliability/components/SectionFaq'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionForm = dynamic(() => import('sections/Benefits/BrandReliability/components/SectionForm'));

type BrandReliabilityProps = {
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
};

export default function BrandReliabilityPage({ pageTitle, formUrl, leadSubtype }: BrandReliabilityProps) {
  return (
    <div className={cn('brand-reliability')}>
      <SectionHeader/>
      <SectionPitch/>
      <SectionCards/>
      <SectionFaq/>
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionForm 
        pageTitle={pageTitle} 
        formUrl={formUrl}
        leadSubtype={leadSubtype}
      /> */}
    </div>
  );
}

export const getStaticProps = async () => {
  // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
  // 'FormParameters' - parameters, passed to 'Form' component on all Benefits pages as an additional data: 
  // const FormParameters = {
  //   pageTitle: LeadFormParameters.brandReliability.pageTitle,
  //   formUrl: LeadFormParameters.brandReliability.formUrl,
  //   leadSubtype: LeadFormParameters.brandReliability.leadSubtype,
  // };

  return {
    props: {
      title: 'Brand Reliability Benefits | DF Alliance',
      description:
        'Learn about DF Alliance\'s brand reliability and commitment to providing trusted, timely, and secure logistics services with a proven track record of excellence.',
      path: '/benefits/brand-reliability',
      // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
      // ...FormParameters,
    },
  };
};

BrandReliabilityPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
